import { AddPeriscopeToInitiativeNotification } from './AddPeriscopeToInitiativeNotification';
import { AddPeriscopeToInitiativeTaskNotification } from './AddPeriscopeToInitiativeTaskNotification';
import React from 'react';
import { RemovePeriscopeFromInitiativeNotification } from './RemovePeriscopeFromInitiativeNotification';

export const PeriscopeInitiativeNotifications: React.FC = () =>
	<>
		<AddPeriscopeToInitiativeNotification />
		<AddPeriscopeToInitiativeTaskNotification />
		<RemovePeriscopeFromInitiativeNotification />
	</>;

